/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
import $ from 'jquery';
import jQuery from 'jquery';
import 'jquery-ui';
import 'jquery-validation';
import DataTable from 'datatables.net-dt';
import Rails from "@rails/ujs";
Rails.start();
window.$ = $;
window.jQuery = jQuery;

import React from 'react';
import { createRoot } from "react-dom/client";
import NotificationsDropdown from "../react/components/notifications_dropdown.js.jsx";
import AutomatedNegotiationsActions from "../react/components/automated_negotiations_actions.js.jsx";


import SmartsettlePanel from '../smartsettle_panel';


window.SmartsettlePanel = SmartsettlePanel
// Optional: loop through all mount points on the page
document.addEventListener("DOMContentLoaded", () => {
  const node = document.getElementById("notifications-dropdown");
  if (node) {
    const props = JSON.parse(node.getAttribute("data-props"));
    const root = createRoot(node);
    root.render(<NotificationsDropdown {...props} />);
  }
  const node2 = document.getElementById("automated-negotiations-actions");
  if (node2) {
    const props2 = JSON.parse(node2.getAttribute("data-props"));
    const root2 = createRoot(node2);
    root2.render(<AutomatedNegotiationsActions {...props2} />);
  }

  $("table[role='datatable']").each(function() {
    const $table = $(this);

    // Prevent initializing twice (important when using Turbo)
    if ($.fn.dataTable.isDataTable(this)) return;

    const ajaxUrl = $table.data('url');
    const locale = $table.data('locale') ? JSON.parse($table.data('locale')) : {};

    $table.DataTable({
      oLanguage: locale,
      processing: true,
      serverSide: true,
      responsive: true,
      bSort: true,
      ajax: ajaxUrl,
      aaSorting: [],
      columnDefs: [
        { responsivePriority: 2, targets: 0 },
        { responsivePriority: 5, targets: 1 },
        { responsivePriority: 100, targets: 2 },
        { responsivePriority: 6, targets: 3 },
        { responsivePriority: 4, targets: -4 },
        { responsivePriority: 3, targets: -3 },
        { responsivePriority: 1, bSortable: false, targets: -1 },
      ],
    });
  });
  $("table[role='document_uploads']").each(function(){
    const $table = $(this);

    // Prevent initializing twice (important when using Turbo)
    if ($.fn.dataTable.isDataTable(this)) return;

    const ajaxUrl = $table.data('url');
    const locale = $table.data('locale') ? JSON.parse($table.data('locale')) : {};

    $(this).DataTable({
      oLanguage: locale
    });
  });
  $("table[role='admin_users']").each(function(){
    const $table = $(this);

    // Prevent initializing twice (important when using Turbo)
    if ($.fn.dataTable.isDataTable(this)) return;

    const ajaxUrl = $table.data('url');
    const locale = $table.data('locale') ? JSON.parse($table.data('locale')) : {};


    $(this).DataTable({
      oLanguage: locale
    });
  });

});
